import { render, staticRenderFns } from "./FunctionizeLoader.vue?vue&type=template&id=52ce5f45&scoped=true"
import script from "./FunctionizeLoader.vue?vue&type=script&lang=js"
export * from "./FunctionizeLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ce5f45",
  null
  
)

export default component.exports